import React from "react";
import { useMsal } from "@azure/msal-react";
import { msalConfig, loginScopes } from "../authConfig";
import Button from "react-bootstrap/Button";


/**
 * Renders a button which, when selected, will redirect the page to the login prompt
 */
export const SignInButton = () => {
    const { instance } = useMsal();

    const accounts = instance.getAllAccounts();
    console.log("Getting all accounts")

    if (accounts.length == 1) {
        console.log("Got an account")
        const account = accounts[0];
        if (account?.tenantId === msalConfig.auth.tenantId) {
            instance.setActiveAccount(account);
        }
    } else if (accounts.length > 1) {
        console.log("Got some accounts")
        accounts.forEach((account) => {
            if (account?.tenantId === msalConfig.auth.tenantId) {
                instance.setActiveAccount(account);
            }
        });
    } else {
        console.log("Trying SSO")
        const queryParams = new URLSearchParams(window.location.search)
        const email = queryParams.get("email")        
        console.log()

        const loginRequest = {
            loginHint: email,
            scopes: loginScopes 
        }

        instance.acquireTokenSilent(loginRequest)
            .catch(function (error) {
                console.log("redirecting, SSO");
                instance.loginRedirect(loginScopes).catch(e => {
                        console.log(e);
                    })
            });        
    }

    const handleLogin = (loginType) => {
        if (loginType === "redirect") {
            instance.loginRedirect(loginScopes).catch(e => {
                console.log(e);
            });
        }
    }
    return (
        <Button variant="secondary" className="ml-auto" onClick={() => handleLogin("redirect")}>Sign in using Redirect</Button>
    );
}